import { Field, IntlField, RawField } from "./SimpleTable.domain"
import { concatClassNames } from "helpers/jsxHelpers"

export const isIntlField = (
	field: Exclude<Field, string>
): field is IntlField => field && (field as IntlField).intl !== undefined

export const mapToFieldCalculated = (
	classNameDefault: string,
	{ className = [], ...rest }: RawField
) => ({
	...rest,
	className: concatClassNames([classNameDefault, ...className]),
})
